import "core-js/actual";
import "../assets/css/nucleo-icons.css";
import "../assets/full-calendar.scss";
import "../assets/scss/black-dashboard-pro-react.scss";
import "../../../tailwind-base.css";
import "./i18n";
import "./sentry";

import { Settings } from "luxon";
import { createRoot } from "react-dom/client";

import Portal from "./Portal";

Settings.defaultLocale = "en";
const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<Portal />);
